module.exports = __webpack_public_path__ + "static/img/t14.b66e0e32.png";